<div class="modal-header">
  <h5 class="modal-title" i18n>Reviews</h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <span><i class="far fa-times"></i></span>
  </button>
</div>

<div class="modal-body mt-0 mb-3 p-0 bg-none">
  <div class="d-flex">
    <div class="flex-fill"></div>
    <app-reviews-filters (filtersChange)="filters = $event" class="my-3" #filtersComponent></app-reviews-filters>
  </div>
  <app-recent-reviews
    [filters]="filters"
    title="Reviews"
    [pager]="true"
    [showHeader]="false"
    [repliable]="true"
    [canSeeReply]="true"
    #reviews
  ></app-recent-reviews>
</div>
